import React, {useEffect, useState} from 'react';

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import FdlOutlinedInput from "../../../utils/FdlOutlinedInput/FdlOutlinedInput";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Divider from "@material-ui/core/Divider";


function AccessRequestModal(props){

  let [reason, setReason] = useState("");

  useEffect(() => {
    setReason("");
  }, [props.open]);

  if (!!!props.vault) {
    return null;
  }

  const createAccessRequest = () => {
    const data = {
      reason: reason
    };
    props.toggleModal();
    props.performVaultAction("CREATE_ACCESS_REQUEST", data);
  };

  return (
    <Dialog open={props.open} className="confirmation-modal">
      <div className="flex items-center between-xs w-full mb-2">
        <div className="flex items-center">
          <FontAwesomeIcon icon="key" size="2x" className="text-warning right-spacer"/>
          <p className="text-lg sm:text-2xl font-bold">Request Access To Vault</p>
        </div>
        <FontAwesomeIcon icon="times" size="lg" className="text-grey cursor-pointer" onClick={props.toggleModal}/>
      </div>
      <Divider/>
      <p className="mb-3 text-sm sm:text-base mt-8">This is the first step to accessing the documents this vault, <b>'{props.vault.vault_name}'</b>.</p>
      <p className="mb-8 text-sm sm:text-base">To access the documents, the Guardians for this vault must approve your request after it is submitted.</p>

      <div className="access-request-note-container">
        <FdlOutlinedInput value={reason}
                          rows={5}
                          label={"Why are you requesting access to this vault?"}
                          placeholder={"This note will be sent to the Guardians of this vault."}
                          onChange={(value) => setReason(value)} />
      </div>
      <Divider className="mt-3 bottom-spacer-medium"/>
      <div className="flex end-xs">
        <Button onClick={props.toggleModal}>
          Cancel
        </Button>

        <Button
          variant="contained"
          color="primary"
          disabled={!!!reason}
          onClick={createAccessRequest}
        >
          Request Access
        </Button>
      </div>

    </Dialog>
  );
}

export default AccessRequestModal;
